// import queryString from "query-string";
import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const insertClaim = async (body: any) => {
  const { data } = await axiosConsumer.post("/insert_claim", body);
  return data?.details || data;
};

export const insertClaimItems = async (body: any) => {
  const { data } = await axiosConsumer.post(`/insert_update_claim_item`, body);

  return data?.results || [];
};

export const removeClaimItem = async (claimItemId) => {
  const { data } = await axiosConsumer.delete(
    `/remove_claim_items/${claimItemId}`
  );
  return data;
};

export const insertClaimItemDamages = async (dto: any) => {
  const { data } = await axiosConsumer.post(`/insert_claim_item_damage`, dto);
  return data || {};
};

export const submitClaim = async (claimId, custId) => {
  const { data } = await axiosConsumer.put(
    `/submit_claim/${claimId}/${custId}`
  );
  return data;
};

export const deleteClaimDamageItem = async (
  id: number | string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.delete(
    `/delete_claim_item_damage/${id}`
  );
  return data;
};

export const deleteClaim = async (id: number | string): Promise<unknown[]> => {
  const { data } = await axiosConsumer.delete(`/delete_draft_claim/${id}`);
  return data;
};

export const getClaim = async (
  claimId: number | string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(`/claim/${claimId}`);
  return data;
};

export const claimItemSaveFileInfo = async (body: any): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(
    `/insert_linked_and_embedded_files`,
    body
  );
  return data?.result || [];
};

export const getPreSignedUrl = async (
  claimId: string,
  fileType: string
): Promise<string | null> => {
  const { data } = await axiosConsumer.get(`/file-upload-url`, {
    params: {
      fileType,
      claimId,
    },
  });
  return data;
};

export const removeClaimPhoto = async (id) => {
  return axiosConsumer.delete(`/delete_uploaded_documents_of_claim/${id}`);
};
